import { render, staticRenderFns } from "./ReviewImages.vue?vue&type=template&id=595a32a6&"
import script from "./ReviewImages.vue?vue&type=script&lang=js&"
export * from "./ReviewImages.vue?vue&type=script&lang=js&"
import style0 from "./ReviewImages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports